import React, { useState } from "react";
import QRCodeStyling from "qr-code-styling";
import JSZip from "jszip";
import { Button, Form, Container } from "react-bootstrap";
import logo1 from "./logo1.png"; // Ensure this path is correct

const BulkQRCodeGenerator = () => {
  const [tagInput, setTagInput] = useState("");
  const [isGenerating, setIsGenerating] = useState(false);

  const handleDownload = async () => {
    const tags = tagInput
      .split(",")
      .map((tag) => tag.trim())
      .filter(Boolean);

    if (tags.length === 0) return;

    setIsGenerating(true);
    const zip = new JSZip();

    for (const tag of tags) {
      const qrCode = new QRCodeStyling({
        width: 300,
        height: 300,
        data: `https://vjqr.in/#/p/${tag}`,
        dotsOptions: { type: "extra-rounded", color: "#112155" },
        imageOptions: {
          crossOrigin: "anonymous",
          imageSize: 0.4,
          hideBackgroundDots: true,
          margin: 5,
        },
        backgroundOptions: { color: "#ffffff", image: logo1 },
        cornersSquareOptions: { type: "extra-rounded", color: "#152860" },
        cornersDotOptions: { type: "", color: "#152860" },
      });

      const blob = await qrCode.getRawData("jpeg");
      zip.file(`${tag}.jpeg`, blob);
    }

    const zipBlob = await zip.generateAsync({ type: "blob" });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(zipBlob);
    link.download = "qr-codes.zip";
    link.click();

    setIsGenerating(false);
  };

  return (
    <Container style={{ maxWidth: "600px", paddingTop: "2rem" }}>
      <h2>Bulk QR Code Generator</h2>
      <Form.Group className="mb-3">
        <Form.Label>Enter Tag Numbers (comma-separated):</Form.Label>
        <Form.Control
          as="textarea"
          rows={4}
          placeholder="e.g. TAG123, TAG456, TAG789"
          value={tagInput}
          onChange={(e) => setTagInput(e.target.value)}
        />
      </Form.Group>
      <Button
        variant="primary"
        onClick={handleDownload}
        disabled={isGenerating}
      >
        {isGenerating ? "Generating..." : "Download All as ZIP"}
      </Button>
    </Container>
  );
};

export default BulkQRCodeGenerator;
